import { EnumMarginType } from '../accommodation';

export class ElementDistribution {
  margin: number;
  marginType: EnumMarginType;
}
